module.exports = __webpack_public_path__ + "img/pay-succ.11d943e4.png";